/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import { mutationOptions, useMutation } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  CreateOperationChainItemMutationRequest,
  CreateOperationChainItemMutationResponse,
} from "../types/CreateOperationChainItem.ts"

export const createOperationChainItemMutationKey = () =>
  [{ url: "/v1/operation-chain/create-operation-chain-item" }] as const

export type CreateOperationChainItemMutationKey = ReturnType<
  typeof createOperationChainItemMutationKey
>

/**
 * @summary Create an operation chain item
 * {@link /v1/operation-chain/create-operation-chain-item}
 */
export async function createOperationChainItem(
  data: CreateOperationChainItemMutationRequest,
  config: Partial<RequestConfig<CreateOperationChainItemMutationRequest>> & {
    client?: typeof fetch
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    CreateOperationChainItemMutationResponse,
    ResponseErrorConfig<Error>,
    CreateOperationChainItemMutationRequest
  >({
    method: "POST",
    url: `/v1/operation-chain/create-operation-chain-item`,
    data: requestData,
    ...requestConfig,
  })
  return res
}

export function createOperationChainItemMutationOptions(
  config: Partial<RequestConfig<CreateOperationChainItemMutationRequest>> & {
    client?: typeof fetch
  } = {}
) {
  const mutationKey = createOperationChainItemMutationKey()
  return mutationOptions<
    ResponseConfig<CreateOperationChainItemMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: CreateOperationChainItemMutationRequest },
    typeof mutationKey
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return createOperationChainItem(data, config)
    },
  })
}

/**
 * @summary Create an operation chain item
 * {@link /v1/operation-chain/create-operation-chain-item}
 */
export function useCreateOperationChainItem<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<CreateOperationChainItemMutationResponse>,
      ResponseErrorConfig<Error>,
      { data: CreateOperationChainItemMutationRequest },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig<CreateOperationChainItemMutationRequest>> & {
      client?: typeof fetch
    }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ?? createOperationChainItemMutationKey()

  const baseOptions = createOperationChainItemMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<CreateOperationChainItemMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: CreateOperationChainItemMutationRequest },
    TContext
  >

  return useMutation<
    ResponseConfig<CreateOperationChainItemMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: CreateOperationChainItemMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<CreateOperationChainItemMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: CreateOperationChainItemMutationRequest },
    TContext
  >
}
